import React from "react";
import { Button, Stack, useThemeProps } from "@mui/material";
import dayjs, { Dayjs, isDayjs } from "dayjs";
import { usePickerActionsContext } from "@mui/x-date-pickers/hooks";

export type DateChangeButtons = {
  onChange?: (date: Dayjs) => Dayjs;
};

export default function DateChangeButtons({ onChange }: DateChangeButtons) {
  const { setValue } = usePickerActionsContext();

  const handleSkipWeek = (weeksToSkip: number) => {
    const targetDate = dayjs().add(weeksToSkip, "weeks");

    if (onChange) {
      const onChangeResult = onChange(targetDate);

      if (isDayjs(onChangeResult)) {
        setValue(onChangeResult, { changeImportance: "set" });
      }
    } else {
      setValue(targetDate, { changeImportance: "set" });
    }
  };

  return (
    <Stack direction={"row"} sx={{ marginTop: "1rem" }}>
      <Button onClick={() => handleSkipWeek(2)}>In 2 Wochen</Button>
      <Button onClick={() => handleSkipWeek(4)}>In 4 Wochen</Button>
    </Stack>
  );
}
